const basicPalette = {
  greyTransparent: {
    100: 'rgba(28,39,50,1)', // #1C2732
    90: 'rgba(28,39,50,.9)',
    80: 'rgba(28,39,50,.8)',
    70: 'rgba(28,39,50,.7)',
    60: 'rgba(28,39,50,.6)',
    50: 'rgba(28,39,50,.5)',
    40: 'rgba(28,39,50,.4)',
    30: 'rgba(28,39,50,.3)',
    20: 'rgba(28,39,50,.2)',
    10: 'rgba(28,39,50,.1)',
    7: 'rgba(28,39,50,.07)',
    4: 'rgba(28,39,50,.04)',
    2: 'rgba(28,39,50,.02)',
    0: 'rgba(28,39,50,0)'
  },
  grey: {
    50: '#f3f5f6',
    75: '#ecf0f1',
    100: '#e2e8ea',
    200: '#ced7db',
    300: '#97abb4',
    400: '#7c929d',
    500: '#637A85', // usually minimum contract for the smaller texts
    600: '#4a5e67',
    700: '#34434b',
    800: '#1c2930',
    900: '#0a141e' // greyDark
  },
  red: {
    50: '#ffe5e5',
    100: '#fcb8b9',
    200: '#f48b8c',
    300: '#ef6969',
    400: '#e83131',
    500: '#ce1817',
    600: '#a11111',
    700: '#740a0b',
    800: '#470405',
    900: '#1e0000'
  },
  green: {
    50: '#DAFFF1',
    100: '#ADFFDB',
    200: '#7CFFC6',
    300: '#4AFFAF',
    400: '#1AFF9A',
    500: '#00AD60',
    600: '#009A55',
    700: '#008549',
    800: '#007038',
    900: '#001C09'
  },
  blue: {
    50: '#ddf2ff',
    100: '#aed4ff',
    200: '#7db8ff',
    300: '#4b9bff',
    400: '#1a7fff',
    500: '#0065E6',
    600: '#004fb4',
    700: '#003882',
    800: '#002251',
    900: '#000b21'
  },
  orange: {
    50: '#fff2dc',
    100: '#fddab3',
    200: '#f8c285',
    300: '#f4aa57',
    400: '#f0932b',
    500: '#d6780f',
    600: '#a75e09',
    700: '#784304',
    800: '#492700',
    900: '#1e0b00'
  },
  yellow: {
    50: '#fff9da',
    100: '#ffedad',
    200: '#ffe17d',
    300: '#ffd54b',
    400: '#ffc91a',
    500: '#e6b000',
    600: '#b38900',
    700: '#806200',
    800: '#4e3b00',
    900: '#1d1400'
  },
  violet: {
    600: '#6400B4'
  }
}

export const brandColors = {
  greyTransparent: { ...basicPalette.greyTransparent },
  grey: {
    ...basicPalette.grey,
    lightest: basicPalette.grey[50],
    lighter: basicPalette.grey[100],
    light: basicPalette.grey[200],
    mid: basicPalette.grey[600],
    dark: basicPalette.grey[900]
  },
  violet: {
    ...basicPalette.violet
  },
  red: {
    ...basicPalette.red,
    mid: basicPalette.red[300],
    dark: basicPalette.red[700]
  },
  blue: {
    ...basicPalette.blue,
    light: basicPalette.blue[100],
    mid: basicPalette.blue[500]
  },
  green: {
    ...basicPalette.green,
    light: basicPalette.green[300],
    mid: basicPalette.green[600],
    dark: basicPalette.green[700],
    darker: basicPalette.green[900]
  },
  orange: {
    ...basicPalette.orange,
    mid: basicPalette.orange[400]
  },
  yellow: {
    ...basicPalette.yellow,
    light: basicPalette.yellow[100],
    mid: basicPalette.yellow[400]
  },
  purple: '#8f4fdc',
  white: '#ffffff',
  black: basicPalette.grey[900],
  success: basicPalette.green[600],

  // Defaults
  navbarBackground: '#ffffff',
  navbarLink: basicPalette.grey[900],
  linkText: basicPalette.green[600],
  buttonPrimary: {
    // Shift by one step for chakra
    50: basicPalette.green[100],
    100: basicPalette.green[200],
    200: basicPalette.green[300],
    300: basicPalette.green[400],
    400: basicPalette.green[500],
    500: basicPalette.green[600],
    600: basicPalette.green[700],
    700: basicPalette.green[800],
    800: basicPalette.green[900],
    900: basicPalette.green[900],
    mid: basicPalette.green[600],
    default: basicPalette.green[600]
  }
}

export const formColors = {
  bgColor: basicPalette.greyTransparent[7],
  hoverBgColor: basicPalette.greyTransparent[10],
  activeBgColor: basicPalette.greyTransparent[10],
  focusBgColor: basicPalette.greyTransparent[10],
  disabledBgColor: basicPalette.greyTransparent[4]
}
